import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import styles from '../shared/PdpSharedDetail/PdpSharedDetail.scss';

type Props = {
    dataTn: string;
    title: ReactNode;
    printHide: boolean | null;
    delimiter?: string | null;
    inlineLabel?: boolean;
    children: ReactNode;
};

export const PdpRespDetail: FC<Props> = ({
    title,
    children,
    dataTn,
    delimiter,
    printHide,
    inlineLabel = false,
}) => {
    const wrapperClasses = classnames(styles.wrapper, dibsCss.breakInsideAvoid, dibsCss.mbXsmall, {
        [styles.printHide]: printHide,
    });
    const titleClasses = classnames(dibsCss.textNoir, dibsCss.sassyFontBodyTypeHeavy, {
        [dibsCss.inline]: inlineLabel,
    });
    const contentClasses = classnames(
        dibsCss.sassyFontBody,
        inlineLabel
            ? dibsCss.inline
            : {
                  [dibsCss.flex]: delimiter,
                  [dibsCss.flexWrap]: delimiter,
                  [dibsCss.block]: !delimiter,
              }
    );
    if (title && children) {
        return (
            <li className={wrapperClasses}>
                <div className={titleClasses} data-tn="pdp-spec-title">
                    {title}
                    {inlineLabel && `: `}
                </div>
                <div className={contentClasses} data-tn={`pdp-spec-${dataTn}`}>
                    {children}
                </div>
            </li>
        );
    }
    return null;
};
